export const WHATSAPP_URL = "https://wa.me/919381497287";

export function whatsappOrderUrl(message) {
  const q = encodeURIComponent(message);
  return `${WHATSAPP_URL}?text=${q}`;
}
